// `icone`/`legenda` são opcionais -- sem eles, comportamento idêntico ao
// original (ícone de moeda + data de hoje no rodapé), preservando as telas
// que já usam este card (Dashboard/Totais, Dashboard/TotaisV2). `legenda`
// troca o rodapé por um texto customizado (sem o ícone de "histórico" nem a
// data), pra telas onde a data de hoje não tem relação com o dado mostrado.
function MinCard(props) {
    let icone = props.icone || "nc-money-coins";

    return (
        <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="card card-stats">
                <div className="card-body ">
                    <div className="row">
                        <div className="col-5 col-md-4">
                            <div className="icon-big text-center icon-warning">
                                <i className={`nc-icon ${icone} text-success`}></i>
                            </div>
                        </div>
                        <div className="col-7 col-md-8">
                            <div className="numbers">
                                <p className="card-category">{props.tipo}</p>
                                <p className="card-title">{props.valor && props.valor.toLocaleString("pt-br", { maximumFractionDigits: 2 , style: 'decimal' })}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer ">
                    <hr />
                    <div className="stats">
                        {props.legenda ? (
                            <><i className="fa fa-calendar"></i> {props.legenda}</>
                        ) : (
                            <><i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}</>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MinCard;